export const localeCookieKey = 'i18nLocale'
